import {
  ModalActionDef,
  ModalDefine,
  ModalStatus
} from '@/libs/formHelper/modalForm/type'
import { Epitaph } from '@/api/epitaph/Epitaph'
import { User } from '@/api/user/User'

export default function getModalDefine (view: any): ModalDefine<Epitaph> {
  const items = [
    {
      title: '头像',
      type: {
        module: 'avatar',
        borderRadius: 0,
        width: 100,
        height: 100,
        gender: (dataItem:User) => {
          return dataItem.gender || 1
        }
      },
      key: 'picture'
    },
    {
      title: '姓名',
      col: { span: 12 },
      required: true,
      key: 'name',
      type: {
        module: 'text',
        maxlength: 20
      }
    },
    {
      title: '生平事迹',
      required: true,
      key: 'deeds',
      type: {
        module: 'textarea',
        limit: 3000
      }
    }
  ]

  const actions: ModalActionDef<Epitaph>[] = [
    {
      key: 'create',
      title: '创建',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.ADD,
      onClick: (item: Epitaph) => {
        return view.onInsertItem(item)
      }
    },
    {
      key: 'modi',
      title: '保存',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.MODI,
      onClick: (item: Epitaph) => {
        return view.onUpdateItem(item)
      }
    }
  ]

  return {
    items,
    actions
  }
}
